import store from "../store"
import Vue from "vue";
import router from "../router"
import {stringify} from "qs";
import Offer from "../components/offer/offer.vue";
import Message from "../components/message/message.vue";
import Location from "../components/location/location.vue";
import User from "../components/user/user.vue";
import ModelModal from "../components/lookup/model-modal.vue";
import Transaction from "../components/transaction/transaction.vue";
import Package from "@/components/package/package.vue";
import BidLineDetailsModal from "@/components/bid/bid-line-details-modal.vue";
import GalleryModal from "@/components/gallery/gallery-modal.vue";
import LeadDetailsModal from "@/components/event/lead-details-modal.vue";
import FileViewModal from "@/components/files/file-view-modal.vue";

const axios = require('axios').default;

class RemoteError extends Error {
    constructor(response) {
        super(response.message || 'Unknown Remote Error')
        this.name = 'RemoteError'
        this.type = response.exception
        this.response = response
    }
}

let last_hash = null

export default {
    rfApp(path, params) {
        this.asyncAction('/api/settings/rfapp', 'get', {
            params: {
                path,
                params
            }
        }).then(({url}) => window.open(url, 'RF Application', 'directories=0,titlebar=0,toolbar=0,location=0,status=0, menubar=0,scrollbars=no,resizable=no, width=380,height=568'))
    },

    withNone(ar) {
        return (typeof ar === 'object') ? [{text: '---- None Selected ----', value: null}, ...ar] : []
    },

    resetUrl() {
        const url = window.location.origin + window.location.pathname
        window.history.replaceState(null, document.title, url)
    },

    copyObjectByKeys(obj, keysToCopy, prefix) {
        prefix = prefix || ''
        return Object.fromEntries(
            keysToCopy.map(key => [`${prefix}${key}`, obj[key]])
        )
    },

    can(perm) {
        return store.getters.can(perm)
    },

    async asyncAction(url, method, options) {
        if (typeof url === "object") {
            if (typeof method === "object")
                options = {...url, ...method}
            else
                options = url

            options.url = options.url || options.href
        }

        const activity = (type) => {
            if (typeof options.noload === 'string')
                store.commit(type, options.noload)
            else if (options.noload !== true)
                store.commit(type)
        }

        const alert = async (err) => await options.quiet ? null : (options.toast ? this.toast(err, 'error') : this.alert(err))

        options = (typeof options == 'object' ? options : {})
        options.url = options.url || url
        options.method = String(options.method || method).toUpperCase()

        if (options.confirm)
            if (!await this.confirm(typeof options.confirm === 'string' ? options.confirm : 'Are you sure?'))
                throw new Error('NO')

        options.headers = (typeof options.headers === 'object') ? options.headers : {}
        if (!options.accept_only)
            options.headers.Accept = 'application/json'

        if (!options.url.startsWith('http://') && !options.url.startsWith('https://'))
            options.withCredentials = true

        if (typeof options.data === 'object' && !(options.data instanceof FormData))
            options.headers['Content-Type'] = 'application/json';

        activity('activity_loading')

        if (typeof options.data == 'object') {
            if (method === 'GET') {
                // convert bools to 0 or 1 in url when url encoded.
                Object.keys(options.data).forEach(function (key, index) {
                    if (typeof options.data[key] == 'boolean')
                        options.data[key] = Number(options.data[key])
                })
                const params = stringify(options.data, {parseBooleans: true})
                options.url = options.url + (options.url.indexOf('?') == -1 ? '?' : '&') + params
            }
        }

        console.log('request', options)
        const perm_hash_check = async (hash, norefresh) => {
            if (!hash)
                return false

            if (!store.getters.isAuthenticated)
                return false

            if (!last_hash) {
                last_hash = hash
                return false
            }

            if (last_hash !== hash) {
                !norefresh && await store.dispatch('settings_load')
                last_hash = hash
                return true
            } else
                last_hash = hash

        }

        try {
            const response = await axios(options);

            console.log('response', response)

            if (!options.no_perm_hash) {
                try {
                    await perm_hash_check(response.headers['x-oms-perm-hash'])
                } catch (e) {
                }
            }

            if (options.accept_only) {
                if (options.accept_only.indexOf(response.headers['content-type']) === -1)
                    throw new Error("Request does not accept content type " + response.headers['content-type'])
            }

            if (typeof response.data !== 'object')
                throw new Error("Malformed Response")
            else
                activity('activity_done')

            if (response.data && response.data._message && response.data._message.length) {
                response.data._message.forEach(message =>  window.vue.$bvToast.toast(message, {
                    title: 'OMS Remote Notice',
                    autoHideDelay: 10000,
                    variant: 'warning',
                }))
            }

            if (options.responseType === 'arraybuffer')
                return Buffer.from(response.data, 'binary').toString('base64');
            else
                return response.data
        } catch (error) {
            activity('activity_done')

            let perm_hash_mismatch = false
            const response = error.response
            let message

            if (response) {
                if (!options.no_perm_hash) {
                    try {
                        perm_hash_mismatch = await perm_hash_check(response.headers['x-oms-perm-hash'], response.status === 403)
                    } catch (e) {
                    }
                }

                if (response.status === 403) {
                    message = 'Permission denied: ' + url
                    if (perm_hash_mismatch) {
                        await this.alert('Permissions have changed, reloading')
                        window.location.href = '/'
                    } else
                        await store.dispatch('settings_load')
                } else if (response.status === 401) {
                    await store.commit('auth_error', 'Session has ended')
                    window.location.reload()
                }

                if (response.data instanceof Blob) {
                    const text = await response.data.text();
                    try {
                        response.data = JSON.parse(text);
                    } catch (e) {
                        console.error('Failed to parse error response as JSON:', e);
                    }
                }

                if (response.data && response.data.message)
                    message = response.data.message
            }

            if (!options.quiet) {
                if (!message)
                    message = error.toString()

                await alert(message)
            }
            if (response?.data?.exception)
                throw new RemoteError(response.data)
            else
                throw error
        }
    },

    toast(message, error, title) {
        window.vue.$bvToast.toast(message, {
            title: title || (error && 'OMS Error') || 'OMS Notification',
            autoHideDelay: 5000,
            variant: (error && 'danger') || 'success',
        })
    },

    alert(message, success) {
        return window.vue.$bvModal.msgBoxOk(message, {
            title: ' ',
            centered: true,
            headerBgVariant: (success && 'success') || 'danger',
            headerTextVariant: 'light'
        })
    },

    confirm(message) {
        return window.vue.$bvModal.msgBoxConfirm(message || 'Are you sure?', {
            title: ' ',
            headerBgVariant: 'warning',
            headerTextVariant: 'light',
            okTitle: 'Yes',
            cancelTitle: 'No',
            centered: true
        })
    },

    gourl(path, newwin) {
        if (newwin)
            window.open(path, '_blank')
        else
            window.location.href = path
    },

    async global_lookup(q, pagenew) {
        if (q) {
            const models = await this.asyncAction('/api/lookup', 'get', {noload: true, params: {q}})

            if (models.length === 1) {
                if (models[0].denied)
                    this.alert('Permission denied, requires ' + models[0].denied)
                else
                    this.modalRoute(models[0], pagenew)
            } else if (models.length > 1)
                Vue.prototype.$dialog.show(ModelModal, {models})

            this.lookup = null
        }
    },

    modalRoute(match, pagenew) {
        if (match.relation) {
            if ((match.model !== 'BidLine') && (match.model !== 'Inventory') && (match.model !== 'Lead'))
                match = match.relation
        }

        const method = pagenew ? function (path) {
            setTimeout(() =>
                window.open(path, '_blank')
            )
        } : (v) => router.push(v)

        const routes = {
            'Customer': () => method(`/customer/${match.id}`),
            'Order': () => method(`/order/${match.id}`),
            'Quote': () => method(`/quote/${match.id}`),
            'ItemOffer': () => Vue.prototype.$dialog.show(Offer, {url: match.url}),
            'Message': () => Vue.prototype.$dialog.show(Message, {url: match.url}),
            'Package': () => Vue.prototype.$dialog.show(Package, {url: match.url}),
            'Item': () => method(`/item/${match.id}`),
            // its page hangs off its item: a lookup result names it (relation); a History entry
            // does not, so that one is looked up by its GLI - which answers with the item
            'Inventory': () => match.relation
                ? method(`/item/${match.relation.id}/inventory/${match.id}`)
                : this.global_lookup(match.gli, pagenew),
            'Location': () => Vue.prototype.$dialog.show(Location, {url: match.url}),
            'User': () => Vue.prototype.$dialog.show(User, {url: match.url}),
            'PhotoGallery': () => Vue.prototype.$dialog.show(GalleryModal, {id: match.id}),
            'Vendor': () => method(`/vendor/${match.id}`),
            'Auction': () => method(`/auction/${match.id}`),
            'PO': () => method(`/po/${match.id}`),
            'Transaction': () => Vue.prototype.$dialog.show(Transaction, {url: match.url}),
            'Bid': () => method(`/bid/${match.id}`),
            'BidLine': () => Vue.prototype.$dialog.show(BidLineDetailsModal, {url: match.url}),
            'Event': () => method(`/event/${match.id}`),
            'MailBatch': () => method(`/mailbatch/${match.id}`),
            'Flight': () => method(`/flights?flight=${match.id}`),
            'Lead': () => Vue.prototype.$dialog.show(LeadDetailsModal, {url: match.url}),
            // a file opens in the app as a popup, or straight in a browser tab when a new page was asked for
            'File': () => pagenew ? method(`/api/file/${match.id}`) : Vue.prototype.$dialog.show(FileViewModal, {url: match.url}),
        };

        if (routes[match.model])
            routes[match.model]();
        else
            this.alert(`No route for ${match.gli} / ${match.model}`);

    },

    popupRightHalf(URL, id) {
        id = id || 'oms'
        const l = screen.availWidth / 2;
        const t = 0;
        const w = screen.availWidth / 2 - 17;
        const h = screen.availHeight - 75;
        const opts = 1;

        eval("window.open(URL, '" + id + "', 'toolbar=" + opts + ", scrollbars=1, location=" + opts + ", addressbar=1, statusbar=1, menubar=" + opts + ", resizable=1, width=" + w + ", height=" + h + ", left=" + l + ", top=" + t + "');");
    },

    copy_to_clipboard(text) {
        navigator.clipboard.writeText(text)
        this.toast('Copied to clipboard')
    },

    download(url, name, toast, data) {
        toast = toast === undefined ? 'File ' + name + ' downloaded' : toast
        return this.asyncAction(url, 'GET', {data, 'responseType': 'blob'})
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                this.toast(toast)
            });
    }
}
